
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'UICountBadge',
  props: {
    count: {
      type: [Number, String],
      default: 0
    },
    isStatic: {
      type: Boolean,
      default: false
    }
  }
})
